/* eslint-disable */
import worker from './worker';
export default worker;
